const bundled = require('../data/words3500.json')

function copyPayload(payload) {
  return { edition: 2027, version: payload.version,
    data: payload.data.map(word => ({ 英文: word.英文, 中文: word.中文, 词性: word.词性 })) }
}

function normalizeGaokaoPayload(payload) {
  // Pre-2027 network responses and caches must never replace the shipped edition.
  if (!payload || payload.edition !== 2027) return copyPayload(bundled)
  if (!payload.version || !Array.isArray(payload.data) || !payload.data.length) {
    throw new Error('2027高考词库数据无效')
  }
  const found = new Set()
  payload.data.forEach(word => {
    if (!word || typeof word.英文 !== 'string' || !word.英文 ||
        typeof word.中文 !== 'string' || !word.中文 ||
        typeof word.词性 !== 'string' || /词汇手册已删除/.test(word.中文) ||
        found.has(word.英文)) throw new Error('2027高考词库包含无效或重复词条')
    found.add(word.英文)
  })
  if (found.size !== bundled.data.length || bundled.data.some(word => !found.has(word.英文))) {
    throw new Error('2027高考词库不完整')
  }
  return copyPayload(payload)
}

function gaokaoDetail(definition) {
  return definition ? `2027年高考3500释义：\n${definition}` : ''
}

function textbookDetail(word) {
  return `${word.教材 || ''} ${word.模块 || ''}\n${word.词性 || ''}\n${word.中文 || word.教材中文 || ''}`.trim()
}

function joinDetails(parts) {
  return parts.filter(Boolean).join('\n-------------------------------\n')
}

function matchesAttribute(selected, attribute) {
  const value = String(selected || '').replace(/[.。]/g, '').toLowerCase().trim()
  const tokens = String(attribute || '').replace(/[.。]/g, '').toLowerCase().split(/[\/／]/).map(token => token.trim())
  return tokens.includes(value) || (value === 'v' && tokens.some(token => token === 'vt' || token === 'vi'))
}

// PC results use 高考中文 so textbook 中文 is never overwritten by the enrichment.
function enrichTextbookResults(results, gaokaoWords) {
  const index = new Map(gaokaoWords.map(word => [word.英文, word]))
  return results.map(result => {
    const word = { ...result }
    const gaokao = index.get(word.英文)
    const definition = gaokao ? gaokao.中文 : ''
    word.高考中文 = definition
    word.简单中文 = (definition || word.教材中文 || word.中文 || '').slice(0, 50)
    word.弹窗中文 = joinDetails([word.弹窗中文 || textbookDetail(word), gaokaoDetail(definition)])
    return word
  })
}

function mergeQueryResults(booksWords, gaokaoWords, allTextbooks) {
  const index = new Map(gaokaoWords.map(word => [word.英文, word]))
  const matched = new Set(booksWords.map(word => word.英文))
  const books = booksWords.map(result => {
    const word = { ...result }
    const gaokao = index.get(word.英文)
    const definition = gaokao ? (gaokao.高考中文 || gaokao.中文 || '') : ''
    word.高考中文 = definition
    word.简单中文 = (definition || word.教材中文 || word.中文 || '').slice(0, 50)
    word.弹窗中文 = joinDetails([word.弹窗中文 || textbookDetail(word), gaokaoDetail(definition)])
    return word
  })
  const gaokao = gaokaoWords.filter(word => !matched.has(word.英文)).map(result => {
    const word = { ...result }
    const textbooks = allTextbooks.filter(item => item.英文 === word.英文)
    const definition = word.高考中文 || word.中文 || ''
    return { ...word, 高考中文: definition, 教材中文: '', 模块: '', 教材: '', 备注: '',
      单元: textbooks.map(item => `${item.教材} ${item.模块}`).join('；'),
      简单中文: definition.slice(0, 50),
      弹窗中文: joinDetails([...textbooks.map(textbookDetail), gaokaoDetail(definition)]) }
  })
  return [...gaokao, ...books]
}

module.exports = { normalizeGaokaoPayload, gaokaoDetail, textbookDetail, joinDetails,
  enrichTextbookResults, mergeQueryResults, matchesAttribute }
